import { type ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { I18nextProvider } from "react-i18next";
import { Toaster } from "sonner";
import i18n from "@/lib/i18n";
import { queryClient } from "@/lib/api/queryClient";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        {children}
        <Toaster
          position="top-right"
          richColors
          closeButton
          visibleToasts={3}
          // Container must not swallow clicks over empty areas (#81); only the
          // toasts themselves stay interactive.
          style={{ pointerEvents: "none" }}
          toastOptions={{ style: { pointerEvents: "auto" } }}
        />
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </I18nextProvider>
  );
}
